
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/UpdateAuthLicense/UpdateAuthLicense.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./UpdateAuthLicense.html');
        
        var script = require('./UpdateAuthLicense.ts').default;
        module.exports = require('./UpdateAuthLicense.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    